import React from "react";

import { CharacterAvatar } from "./CharacterAvatar/CharacterAvatar";
import { CharacterIdentity } from "./CharacterIdentity/CharacterIdentity";

import "./CharacterRow.scss";

export const CharacterRow = (props)=>{
    const { profile, showMe } = props;

    return (
        <section className="CharacterRow">
            <CharacterAvatar profile={profile} showMe={showMe}/>
            <CharacterIdentity profile={profile} showMe={showMe}/>
        </section>
    );
};
